import { Record, List, Map, fromJS } from 'immutable';

const defaultValues = {
  id: null,
  templateId: null,
  stateId: null,
  locationId: null,
  title: '',
  description: 'Enter a description',
  cost: 0,
  userProcessStep: null,
  archived: false,
  createdBy: null,
  created: null,
  updatedBy: null,
  updated: null,
  menuItemCount: 0,
  itemsMap: new Map(),
  menuItems: new List(),
  menuItemsMap: new Map(),
  visible: false,
  visibleAccess: false,
  lockedByOther: false,
  lockedByOtherName: null,
  periodId: null,
  periodName: '',
};

export default class Menu extends Record(defaultValues, Menu) {
  constructor(values) {
    super({
      ...values,
      itemsMap: values && values.itemsMap ? fromJS(values.itemsMap) : defaultValues.itemsMap,
      menuItems: values && values.menuItems ? fromJS(values.menuItems) : defaultValues.menuItems,
      menuItemsMap: values && values.menuItemsMap
                    ? fromJS(values.menuItemsMap) : defaultValues.menuItemsMap,
    });
  }

  addMenuItem(menuItem) {
    return this.set('menuItems', this.get('menuItems').push(menuItem));
  }

  findMenuItem(id) {
    return this.get('menuItems').find((item) => {
      return item.id === id ? item : undefined;
    });
  }

  static getActiveMenus(menus) {
    return menus.filter((menu) => {
      return menu.get('archived') === false;
    });
  }

  static getArchivedMenus(menus) {
    return menus.filter((menu) => {
      return menu.get('archived') === true;
    });
  }

  static filterMenusByMenuName(menus, keywords) {
    let keywordsUpper = keywords.toUpperCase();
    return menus.filter((menu) => {
      return menu.get('title') && menu.get('title').toUpperCase().includes(keywordsUpper);
    });
  }

  static filterMenuById(menus, id) {
    return menus.filter((menu) => {
      return menu.get('id') == id;
    });
  }

  static getInvisibleMenus(menus) {
    return menus.filter((menu) => {
      return menu.get('visible') === false;
    });
  }
}

export const Menus = (data) => {
  let menus = new List();
  if (data) {
    data.forEach((value) => {
      menus = menus.push(new Menu(value));
    });
  }
  return menus;
};
